var _circle, _rect, _rect2, _path, _path2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 100",
    width: 400,
    height: 100,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 30,
    fill: "yellow",
    stroke: "black",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 70,
    width: 20,
    height: 10,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 80,
    width: 10,
    height: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 65C30 55 20 50 20 35C20 20 35 10 50 10",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 65C70 55 80 50 80 35C80 20 65 10 50 10",
    stroke: "black",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 55,
    fontFamily: "Arial, sans-serif",
    fontSize: 30,
    fontWeight: "bold",
    fill: "blue"
  }, "\n        BrightMinds\n    ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 285,
    y: 55,
    fontFamily: "Arial, sans-serif",
    fontSize: 30,
    fontWeight: "bold",
    fill: "red"
  }, "\n        STEM\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.8525348df1fb5dad79bba07aa1b73d6c.svg";
export { ForwardRef as ReactComponent };